import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { ReferAFriendAlert } from "~/features/Referral/ReferAFriendAlert";
import { FieldsWrapper } from "./FieldsWrapper";

export const FormBox: FC = () => {
  return (
    <Flex align="center" direction="column" gap={8} justify="space-between">
      <ReferAFriendAlert bgColor="th.yellow1" page="planPayment" />
      <FieldsWrapper />
    </Flex>
  );
};
